import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { getAllClaimTypesAPI, getSingleClaimTypesAPI } from "./claimTypes.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

const useAllClaimTypesService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: ICommonServiceProps) => {
  const [searchClaimTypesQuery, setSearchClaimTypesQuery] =
    useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchClaimTypesQuery);
  const allClaimTypesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CLAIM_TYPES,
      debouncedQuery,
      page,
      per_page,
      ...cacheKeys,
    ],
    queryFn: () =>
      getAllClaimTypesAPI({
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchClaimTypesQuery, setSearchClaimTypesQuery },
    services: { allClaimTypesService },
  };
};

const useSingleClaimTypesService = ({
  singleClaimTypesId,
  enableQuery = true,
}: {
  singleClaimTypesId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.CLAIM_TYPES, singleClaimTypesId],
    queryFn: () => getSingleClaimTypesAPI(singleClaimTypesId),
    enabled: !!singleClaimTypesId && enableQuery,
  });
};

export { useAllClaimTypesService, useSingleClaimTypesService };
